module.exports = __webpack_public_path__ + "img/tv.83a8d80c.svg";